import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "input-group mb-3" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "input-group mb-3" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "text-danger text-sm"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "text-danger text-sm"
}
const _hoisted_18 = {
  key: 1,
  class: "row"
}
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "input-group mb-3" }
const _hoisted_21 = ["placeholder", "disabled"]
const _hoisted_22 = {
  key: 2,
  class: "row"
}
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "input-group mb-3" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 3,
  class: "row"
}
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "input-group mb-3" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { key: 4 }
const _hoisted_31 = {
  key: 5,
  class: "row"
}
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "d-flex align-items-center gap-2" }
const _hoisted_34 = {
  for: "internal",
  style: {"cursor":"pointer","margin-bottom":"0"}
}
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "d-flex align-items-center gap-2" }
const _hoisted_37 = {
  for: "external",
  style: {"cursor":"pointer","margin-bottom":"0"}
}
const _hoisted_38 = { key: 6 }
const _hoisted_39 = { key: 7 }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "input-group mb-3" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "input-group mb-3" }
const _hoisted_46 = ["required", "placeholder"]
const _hoisted_47 = {
  key: 0,
  class: "row"
}
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "input-group mb-3" }
const _hoisted_50 = ["required", "placeholder"]
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "input-group mb-3" }
const _hoisted_54 = ["required", "placeholder"]
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "input-group mb-3" }
const _hoisted_57 = ["required", "placeholder"]
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = {
  key: 0,
  class: "input-group mb-3"
}
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 1,
  class: "input-group mb-3"
}
const _hoisted_63 = {
  key: 1,
  class: "row"
}
const _hoisted_64 = { class: "col" }
const _hoisted_65 = { class: "input-group mb-3" }
const _hoisted_66 = {
  key: 2,
  class: "row"
}
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "input-group mb-3" }
const _hoisted_69 = ["required", "placeholder"]
const _hoisted_70 = { key: 8 }
const _hoisted_71 = {
  key: 0,
  class: "col-md-3 d-flex align-items-center gap-2"
}
const _hoisted_72 = ["onUpdate:modelValue", "id"]
const _hoisted_73 = ["for"]
const _hoisted_74 = {
  key: 1,
  class: "col"
}
const _hoisted_75 = ["disabled", "onUpdate:modelValue", "placeholder"]
const _hoisted_76 = {
  key: 9,
  class: "row mt-2 ms-auto"
}
const _hoisted_77 = { style: {"font-size":"0.85em"} }
const _hoisted_78 = {
  key: 10,
  class: "container-skel"
}
const _hoisted_79 = {
  key: 11,
  class: "row"
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info-reverse"
}
const _hoisted_82 = {
  key: 0,
  class: "fas fa-save"
}
const _hoisted_83 = {
  key: 2,
  class: /*@__PURE__*/_normalizeClass('col-12 mt-3')
}
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 3,
  class: /*@__PURE__*/_normalizeClass('col-12')
}
const _hoisted_86 = {
  class: "btn-register-main",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.IsSubscription ? 'modal-body' : 'col'),
        style: {"max-height":"80vh","overflow-y":"auto"}
      }, [
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
                    placeholder: _ctx.$t('first') + ' ' + _ctx.$t('name'),
                    required: "",
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNameChange && _ctx.onNameChange(...args)))
                  }, null, 40, _hoisted_4), [
                    [_vModelText, _ctx.form.firstName]
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-user" })
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastName) = $event)),
                    placeholder: _ctx.$t('last') + ' ' + _ctx.$t('name'),
                    required: "",
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNameChange && _ctx.onNameChange(...args)))
                  }, null, 40, _hoisted_7), [
                    [_vModelText, _ctx.form.lastName]
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-user" })
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.displayName) = $event)),
                    placeholder: _ctx.$t('displayName'),
                    required: ""
                  }, null, 8, _hoisted_10), [
                    [_vModelText, _ctx.form.displayName]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-id-card" })
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control input-sm rounded-end-0",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.organizationName) = $event)),
                placeholder: _ctx.$t('organization') + ' ' + _ctx.$t('name'),
                required: ""
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.form.organizationName]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                _createElementVNode("span", { class: "fas fa-sitemap" })
              ], -1))
            ]),
            (_ctx.form.organizationName && !_ctx.isOrganizationNameUnique)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Organization already exists."))
              : _createCommentVNode("", true),
            (_ctx.form.organizationName && !_ctx.isOrganizationNameUnique && !_ctx.isOrganizationNameValid)
              ? (_openBlock(), _createElementBlock("br", _hoisted_16))
              : _createCommentVNode("", true),
            (_ctx.form.organizationName && !_ctx.isOrganizationNameValid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Special charcters are not allowed!"))
              : _createCommentVNode("", true)
          ])
        ]),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                    placeholder: _ctx.$t('email'),
                    disabled: _ctx.IsUpdate,
                    required: ""
                  }, null, 8, _hoisted_21), [
                    [_vModelText, _ctx.form.email]
                  ]),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-envelope" })
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.password) = $event)),
                    placeholder: _ctx.$t('password'),
                    required: ""
                  }, null, 8, _hoisted_25), [
                    [_vModelText, _ctx.form.password]
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-lock" })
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control input-sm rounded-end-0",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                    placeholder: _ctx.$t('retype') + ' ' + _ctx.$t('password')
                  }, null, 8, _hoisted_29), [
                    [_vModelText, _ctx.form.confirmPassword]
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "input-group-text rounded-start-0" }, [
                    _createElementVNode("span", { class: "fas fa-lock" })
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("br", _hoisted_30))
          : _createCommentVNode("", true),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input mt-0",
                    type: "radio",
                    id: "internal",
                    value: false,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.useExternalDB) = $event)),
                    name: "internalExternal",
                    checked: "",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangesuseExternalDB()))
                  }, null, 544), [
                    [_vModelRadio, _ctx.form.useExternalDB]
                  ]),
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('use') + ' ' + _ctx.$t('internal') + ' ' + _ctx.$t('database')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input mt-0",
                    type: "radio",
                    id: "external",
                    value: true,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.useExternalDB) = $event)),
                    name: "internalExternal",
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangesuseExternalDB()))
                  }, null, 544), [
                    [_vModelRadio, _ctx.form.useExternalDB]
                  ]),
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('use') + ' ' + _ctx.$t('external') + ' ' + _ctx.$t('database')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("br", _hoisted_38))
          : _createCommentVNode("", true),
        (_ctx.form.useExternalDB && !_ctx.IsUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control input-sm",
                      id: "internal",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.authenticationType) = $event)),
                      name: "authenticationType",
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetServerInfo())),
                      style: {"padding-left":"6px !important"}
                    }, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("option", { value: 1 }, "SQL Server Authentication", -1),
                      _createElementVNode("option", { value: 2 }, "Entra Service Principle Authentication", -1)
                    ]))], 544), [
                      [_vModelSelect, _ctx.form.authenticationType]
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "input-group-append" }, [
                      _createElementVNode("div", { class: "input-group-text" }, [
                        _createElementVNode("span", { class: "fas fa-cloud" })
                      ])
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.sqlServerName) = $event)),
                      class: "form-control input-sm",
                      required: _ctx.form.useExternalDB,
                      placeholder: _ctx.$t('serverName')
                    }, null, 8, _hoisted_46), [
                      [_vModelText, _ctx.form.sqlServerName]
                    ]),
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "input-group-append" }, [
                      _createElementVNode("div", { class: "input-group-text" }, [
                        _createElementVNode("span", { class: "fas fa-server" })
                      ])
                    ], -1))
                  ])
                ])
              ]),
              (_ctx.form.authenticationType == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.tenantId) = $event)),
                          class: "form-control input-sm",
                          required: _ctx.form.useExternalDB && _ctx.form.authenticationType == 2,
                          placeholder: _ctx.$t('tenantId')
                        }, null, 8, _hoisted_50), [
                          [_vModelText, _ctx.form.tenantId]
                        ]),
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("div", { class: "input-group-text" }, [
                            _createElementVNode("span", { class: "fas fa-cog" })
                          ])
                        ], -1))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.sqlServerUserName) = $event)),
                      required: _ctx.form.useExternalDB,
                      placeholder: _ctx.form.authenticationType == 1 ? _ctx.$t('serverUserName') : _ctx.$t('clientId')
                    }, null, 8, _hoisted_54), [
                      [_vModelText, _ctx.form.sqlServerUserName]
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "input-group-append" }, [
                      _createElementVNode("div", { class: "input-group-text" }, [
                        _createElementVNode("span", { class: "fas fa-server" })
                      ])
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.sqlServerPassword) = $event)),
                      required: _ctx.form.useExternalDB,
                      placeholder: _ctx.form.authenticationType == 1 ? _ctx.$t('serverPassword') : _ctx.$t('clientSecret')
                    }, null, 8, _hoisted_57), [
                      [_vModelText, _ctx.form.sqlServerPassword]
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "input-group-append" }, [
                      _createElementVNode("div", { class: "input-group-text" }, [
                        _createElementVNode("span", { class: "fas fa-key" })
                      ])
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (!_ctx.isConnectLoader)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.hasServerInformationToRetrieveDb,
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onCheckDbConnection())),
                          class: "btn btn-block btn-outline-success"
                        }, _toDisplayString(_ctx.$t('fetchDatabases')), 9, _hoisted_61)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isConnectLoader && !_ctx.IsSubscription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [...(_cache[38] || (_cache[38] = [
                        _createElementVNode("button", {
                          class: "btn btn-block btn-outline-success",
                          type: "button",
                          disabled: ""
                        }, [
                          _createElementVNode("span", {
                            class: "spinner-border spinner-border-sm",
                            role: "status",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" Loading... ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.listDatabases.length > 0 && !_ctx.isConnectLoader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_ejs_dropdownlist, {
                          id: "databaseTree",
                          modelValue: _ctx.form.databaseName,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.databaseName) = $event)),
                          dataSource: _ctx.listDatabases,
                          placeholder: _ctx.$t("database")
                        }, null, 8, ["modelValue", "dataSource", "placeholder"])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.databaseName) = $event)),
                          class: "form-control input-sm",
                          required: _ctx.form.useExternalDB,
                          placeholder: _ctx.$t('database')
                        }, null, 8, _hoisted_69), [
                          [_vModelText, _ctx.form.databaseName]
                        ]),
                        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("div", { class: "input-group-text" }, [
                            _createElementVNode("span", { class: "fas fa-server" })
                          ])
                        ], -1))
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.moduleCheckBox?.length > 0 && !_ctx.isModuleLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModule, (module, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row mt-2",
                  key: module.id
                }, [
                  (_ctx.form.moduleCheckBox[index])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.moduleCheckBox[index].isChecked) = $event),
                          id: 'module' + index
                        }, null, 8, _hoisted_72), [
                          [_vModelCheckbox, _ctx.form.moduleCheckBox[index].isChecked]
                        ]),
                        _createElementVNode("label", {
                          for: 'module' + index,
                          class: "mb-0"
                        }, _toDisplayString(module.displayName), 9, _hoisted_73)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.form.moduleCheckBox[index])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          disabled: !_ctx.serverInformationProvided || !_ctx.form.moduleCheckBox[index].isChecked,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.moduleCheckBox[index].schemaName) = $event),
                          class: "form-control input-sm",
                          type: "text",
                          placeholder: `${module.displayName} schema`
                        }, null, 8, _hoisted_75), [
                          [_vModelText, _ctx.form.moduleCheckBox[index].schemaName]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.IsSubscription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("span", _hoisted_77, "*" + _toDisplayString(`${_ctx.$t('note')} : ${_ctx.$t('msgRenameSchema')}`), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isModuleLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [...(_cache[40] || (_cache[40] = [
              _createStaticVNode("<div class=\"post-skel\" data-v-e5dc9d26><div class=\"line-skel\" data-v-e5dc9d26></div></div><div class=\"post-skel\" data-v-e5dc9d26><div class=\"line-skel\" data-v-e5dc9d26></div></div><div class=\"post-skel\" data-v-e5dc9d26><div class=\"line-skel\" data-v-e5dc9d26></div></div>", 3)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.form.moduleCheckBox?.length == 0 && !_ctx.isModuleLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [...(_cache[41] || (_cache[41] = [
              _createElementVNode("div", {
                class: "alert alert-warning alert-dismissible fade show",
                role: "alert"
              }, [
                _createTextVNode(" There is no "),
                _createElementVNode("strong", null, "modules"),
                _createTextVNode(" to select for subscription. and you can't register without selecting any module. Please contact to the administartor. "),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close"
                }, [
                  _createElementVNode("span", { "aria-hidden": "true" }, "×")
                ])
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.IsSubscription ? 'modal-footer' : 'row'),
        style: {"position":"sticky","bottom":"0","background":"white"}
      }, [
        (_ctx.IsSubscription)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-sm btn-outline-close",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.close()))
            }, [
              _cache[42] || (_cache[42] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('close')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.IsSubscription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
              _createElementVNode("button", _hoisted_81, [
                (_ctx.IsSubscription)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_82))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.IsUpdate ? _ctx.$t('update') : _ctx.$t('save')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsSubscription && !_ctx.isRegisterLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("button", {
                disabled: _ctx.form.moduleCheckBox?.length == 0,
                type: "submit",
                class: "btn-register-main"
              }, _toDisplayString(_ctx.$t('register')), 9, _hoisted_84)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsSubscription && _ctx.isRegisterLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
              _createElementVNode("button", _hoisted_86, [
                _cache[43] || (_cache[43] = _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm me-2",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('loading')) + "... ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 32),
    _createElementVNode("input", {
      id: "subsWiseModulesId",
      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onLoadRegisterAfterSubscribe())),
      type: "hidden"
    }, null, 32)
  ], 64))
}